import { wrapCollectionLayout } from "@quintype/components";
import React from "react";

import FourStoryHalfFeatured from "../rows/FourStoryHalfFeatured";
import SliderFocusedCard from "../rows/SliderFocusedCard";
import NineStories from "../rows/NineStories";
import FiveOpinionStories from "../rows/FiveOpinionStories";
import FourStories from "../rows/FourStories";
import FourteenStories3Ad1Widget from "../rows/FourteenStories3Ad1Widget";
import FourteenStories2Ads1Widget from "../rows/FourteenStories2Ads1Widget";
import PhotoStoryWithSlider from "../rows/PhotoStoryWithSlider";
import FourCollection12Stories1Ad from "../rows/FourCollection12Stories1Ad";
import SixStories1AdWithTagSearch from "../rows/SixStories1AdWithTagSearch";
import SixStories1WidgetWithPoll from "../rows/SixStories1WidgetWithPoll";
import FourCollection12Stories from "../rows/FourCollection12Stories";
import TenStories2AdWithLoadMore from "../rows/TenStories2AdWithLoadMore";
import SixteenStories3AdWithTagSearchAndLoadMore from "../rows/SixteenStories3AdWithTagSearchAndLoadMore";
import SixteenStories1WidgetWithPollAndLoadMore from "../rows/SixteenStories1WidgetWithPollAndLoadMore";
import FiveVideoStories from "../rows/FiveVideoStories";
import BigPhotoStoryCardSlider1Ad from "../rows/BigPhotoStoryCardSlider1Ad";
import BigVideoStoryCard2Ad from "../rows/BigVideoStoryCard2Ad";
import FourColStoriesWithLoadMore from "../rows/FourColStoriesWithLoadMore";
import FourStoryCards from "../rows/FourStoryCards";
import FourteenStories2AdBigFact from "../rows/FourteenStories2AdBigFact";
import TwelveStoryOneAdsOneWidget from "../rows/TwelveStoryOneAdsOneWidget";
import OneColThreeStoriesSlider from "../rows/OneColThreeStoriesSlider";
import WidgetOrAdvertisement from "../rows/WidgetOrAdvertisement";

function wrapEager(f) {
  return function WrapEager(props) {
    const { collection, liveBlogStory, mostCommentedStories } = props;
    if (props.metadata.layout === "FourteenStories3Ad1Widget") {
      return React.createElement(f, { collection, liveBlogStory });
    } else return React.createElement(f, { collection, mostCommentedStories });
  };
}

export default {
  FourStoryHalfFeatured: wrapEager(wrapCollectionLayout(FourStoryHalfFeatured)),
  SliderFocusedCard: wrapEager(wrapCollectionLayout(SliderFocusedCard)),
  NineStories: wrapEager(wrapCollectionLayout(NineStories)),
  FiveOpinionStories: wrapEager(wrapCollectionLayout(FiveOpinionStories)),
  FourStories: wrapEager(wrapCollectionLayout(FourStories)),
  FourteenStories3Ad1Widget: wrapEager(wrapCollectionLayout(FourteenStories3Ad1Widget)),
  FourteenStories2Ads1Widget: wrapEager(wrapCollectionLayout(FourteenStories2Ads1Widget)),
  PhotoStoryWithSlider: wrapEager(wrapCollectionLayout(PhotoStoryWithSlider)),
  FourCollection12Stories1Ad: wrapEager(wrapCollectionLayout(FourCollection12Stories1Ad)),
  SixStories1AdWithTagSearch: wrapEager(wrapCollectionLayout(SixStories1AdWithTagSearch)),
  SixStories1WidgetWithPoll: wrapEager(wrapCollectionLayout(SixStories1WidgetWithPoll)),
  FourCollection12Stories: wrapEager(wrapCollectionLayout(FourCollection12Stories)),
  TenStories2AdWithLoadMore: wrapEager(wrapCollectionLayout(TenStories2AdWithLoadMore)),
  FiveVideoStories: wrapEager(wrapCollectionLayout(FiveVideoStories)),
  FourStoryCards: wrapEager(wrapCollectionLayout(FourStoryCards)),
  BigPhotoStoryCardSlider1Ad: wrapEager(wrapCollectionLayout(BigPhotoStoryCardSlider1Ad)),
  BigVideoStoryCard2Ad: wrapEager(wrapCollectionLayout(BigVideoStoryCard2Ad)),
  FourColStoriesWithLoadMore: wrapEager(wrapCollectionLayout(FourColStoriesWithLoadMore)),
  SixteenStories3AdWithTagSearchAndLoadMore: wrapEager(wrapCollectionLayout(SixteenStories3AdWithTagSearchAndLoadMore)),
  SixteenStories1WidgetWithPollAndLoadMore: wrapEager(wrapCollectionLayout(SixteenStories1WidgetWithPollAndLoadMore)),
  FourteenStories2AdBigFact: wrapEager(wrapCollectionLayout(FourteenStories2AdBigFact)),
  OneColThreeStoriesSlider: wrapEager(wrapCollectionLayout(OneColThreeStoriesSlider)),
  TwelveStoryOneAdsOneWidget: wrapEager(wrapCollectionLayout(TwelveStoryOneAdsOneWidget)),
  WidgetOrAdvertisement: wrapEager(wrapCollectionLayout(WidgetOrAdvertisement)),
  defaultTemplate: wrapEager(wrapCollectionLayout(OneColThreeStoriesSlider)),
};
